module.exports = __webpack_public_path__ + "img/2.a2b392f5.png";